import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { getCurrentAsterAssets } from './getCurrentAsset'
import { incomeHistoryApiConfig } from './incomeHistory/constants'
import { fetchApiData as fetchIncomeHistoryApiData } from './incomeHistory/fetchApiData'
import { tradeHistoryApiConfig } from './tradeHistory/constants'
import { fetchApiData as fetchTradeHistoryApiData } from './tradeHistory/fetchApiData'

export const asterApiConfigs = {
  [tradeHistoryApiConfig.type]: tradeHistoryApiConfig,
  [incomeHistoryApiConfig.type]: incomeHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type AsterApiType = keyof typeof asterApiConfigs

export const asterApiTypes = Object.keys(asterApiConfigs) as AsterApiType[]

export const fetchAsterApiDataFuncs = {
  [tradeHistoryApiConfig.type]: fetchTradeHistoryApiData,
  [incomeHistoryApiConfig.type]: fetchIncomeHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchAsterSubTypesFuncs = {
  [tradeHistoryApiConfig.type]: undefined,
  [incomeHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentAsterAssets }
